import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from './ProductCard.module.scss';
import OrderModal from '../OrderModal/OrderModal';
import 'aos/dist/aos.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useUsers from '../../hooks/useUsers';
import { useDispatch } from 'react-redux';
import { setProduct, setProductId } from '../../redux/slices/productSlice';
import useScreenSize from '../../hooks/useScreenSize';

function ProductCard(props) {
    const {
        id,
        name,
        stock_status,
        files,
        price,
        old_price,
        is_active,
        products_type,
        navigation,
        monthly_payment_amount,
        leasing_amount,
        max_leasing_time,
        leasing_calculator_status,
        products_amount,
        by_order,
    } = props;
    const [showModal, setShowModal] = useState(false);
    const dispatch = useDispatch();
    const { categoryName, brandName, productItem, productId } = useParams();
    const { pathname } = useLocation();
    const { getProductById } = useUsers();
    const navigate = useNavigate();
    const [isHovered, setIsHovered] = useState(false);
    const { isMobile } = useScreenSize();
    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    const handleGoToProductItem = (e, id, name) => {
        if (e.target.tagName === 'SPAN') return;
        dispatch(setProductId(id));
        getProductById(id).then((data) => {
            if (data.data) {
                dispatch(setProduct(data.data));
            }
        });
        navigator(id);
    };

    function navigator(id) {
        const values = navigation?.map((item) => item?.slug?.toLowerCase());
        let path = '';
        if (!categoryName && !brandName && !productItem && !productId) {
            path = `/${values[0]}/${values[1]}/${values[2]?.replace(/ /g, '')}/${id}`;
            navigate(path);
        } else if (categoryName && brandName && productItem && productId) {
            path = `/${values[0]}/${values[1]}/${values[2]?.replace(/ /g, '')}/${id}`;
            navigate(path);
        } else if (categoryName && brandName) {
            path = `${values[2]?.replace(/ /g, '')}/${id}`;
            navigate(path);
        } else if (categoryName) {
            path = `${values[1]}/${values[2]?.replace(/ /g, '')}/${id}`;
            navigate(path);
        }
    }

    const handleInterested = (e) => {
        e.stopPropagation();
        setShowModal(!showModal);
    };

    return (
        <>
            {showModal && (
                <OrderModal
                    handleInterested={handleInterested}
                    id={id}
                    productName={name}
                />
            )}
            {is_active === 1 && (
                <div
                    onClick={(e) => handleGoToProductItem(e, id, name)}
                    className={styles.productCard__link}
                    style={{ transform: isHovered ? 'scale(1.05)' : null }}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <div className={styles.combineItem}>
                        <div className={styles.combineItem__details}>
                            <div className={styles.combineItem__info}>
                                <h3>{name}</h3>
                                <div className={styles.combineItem__badge}>
                                    <div
                                        className={styles.combineItem_badgeItem}
                                        style={{
                                            backgroundColor:
                                                by_order === 1
                                                    ? 'blue'
                                                    : stock_status === 'in_stock'
                                                        ? '#0AA349'
                                                        : null,
                                        }}
                                    ></div>
                                    <div>
                                        {by_order === 1
                                            ? 'Sifarişlə'
                                            : stock_status === 'in_stock'
                                                ? 'Mövcuddur'
                                                : 'Mövcud deyil'}
                                    </div>
                                </div>
                            </div>

                            <div className={styles.combineItem__photos}>
                                {!isHovered ? (
                                    <img
                                        src={
                                            files[0]?.filename !== 'Youtube'
                                                ? files[0]?.path
                                                : files[1]?.path
                                        }
                                    />
                                ) : (
                                    <div>
                                        <Swiper
                                            spaceBetween={30}
                                            pagination={{
                                                clickable: true,
                                            }}
                                            modules={[Pagination]}
                                            className="mySwiper"
                                        >
                                            {files?.length >= 4 ? (
                                                files.slice(0, 4).map((item, index) => (
                                                    <SwiperSlide key={index}>
                                                        <img src={item?.path} alt="" />
                                                    </SwiperSlide>
                                                ))
                                            ) : (
                                                <img
                                                    src={
                                                        files[0]?.filename !== 'Youtube'
                                                            ? files[0]?.path
                                                            : files[1]?.path
                                                    }
                                                    alt=""
                                                />
                                            )}
                                        </Swiper>
                                    </div>
                                )}
                            </div>

                            {/* Hide price and monthly payment amount if by_order === 1 */}
                            {by_order !== 1 && (
                                <>
                                    <div className={styles.combineItem__prices}>
                                        <div className={styles.combineItem__currentPrice}>
                                            {price} AZN
                                        </div>
                                    </div>

                                    {(isMobile || isHovered) && leasing_calculator_status !== 0 && (
                                        <div className={styles.monthly_payment_amount}>
                                            Aylıq ödəniş : {Math.round((leasing_amount) / (max_leasing_time))} AZN
                                        </div>
                                    )}
                                </>
                            )}

                            <div
                                style={isMobile ? { display: 'none' } : { display: 'flex' }}
                                className={styles.combineItem__btns}
                            >
                                <button className="lightBtn">Ətraflı</button>
                                <button onClick={(e) => handleInterested(e)} className="mainBtn">
                                    Maraqlanıram
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default ProductCard;

